import React, {Component} from 'react';
import {Form} from 'reactstrap';

class ProgramCombo extends Component {
	render() {
		let classNames = '';
		if (this.props.controller) {
			classNames =
        this.props.localFocus === this.props.comboFocus ?
        	'combo-focused' :
        	'combo-unfocused';
		}

		return (
			<Form
				inline
				className={classNames}
				onClick={() => {
					this.props.changeComboFocus(this.props.localFocus);
				}}
				onSubmit={(e) => {
					e.preventDefault();
					return false;
				}}
			>
				{this.props.labelChild} {this.props.inputChild}
			</Form>
		);
	}
}

export default ProgramCombo;



// WEBPACK FOOTER //
// ./src/components/ProgramCombo.js